import WebinarLinkIcon from './component.jsx'
export default WebinarLinkIcon
